import { render, staticRenderFns } from "./Mam.vue?vue&type=template&id=433ef2b2"
import script from "./Mam.vue?vue&type=script&lang=js"
export * from "./Mam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports